export default "__VITE_ASSET__BYNrK1Na__"